import React from 'react';

import Searcher from 'components/DesignSystem/Searcher';
import Icon from 'components/DesignSystem/Icon';
import { cssVar } from 'constants/theme';

import './index.scss';

export interface MobileToolbarProps {
  searchValue: string;
  onSearchChange: React.ChangeEventHandler<HTMLInputElement>;
  setSearchQuery: (text: string) => void;
  searchId: string;
  searchPlaceholder: string;
  filterActive: boolean;
  filterAriaLabel: string;
  appliedFilters: React.ReactNode[];
  onFilterClick: () => void;
  onClearAll: () => void;
  resultsCount: number;
  resultsNoun: string;
  loading: boolean;
  trailingAction?: React.ReactNode;
}

export default function MobileToolbar({
  searchValue,
  onSearchChange,
  setSearchQuery,
  searchId,
  searchPlaceholder,
  filterActive,
  filterAriaLabel,
  appliedFilters,
  onFilterClick,
  onClearAll,
  resultsCount,
  resultsNoun,
  loading,
  trailingAction,
}: MobileToolbarProps) {
  const plural = resultsCount === 1 ? '' : 's';

  return (
    <>
      <div className="mobile-toolbar">
        <Searcher
          className="mobile-toolbar-search"
          value={searchValue}
          onChange={onSearchChange}
          setSearchQuery={setSearchQuery}
          id={searchId}
          placeholder={searchPlaceholder}
        />
        <button
          type="button"
          aria-label={filterAriaLabel}
          className={`mobile-toolbar-filter-button${filterActive ? ' active' : ''}`}
          onClick={onFilterClick}
        >
          <Icon iconType="filter" color={cssVar(filterActive ? 'text-on-accent' : 'text-secondary')} size="small" />
          {filterActive && (
            <span className="mobile-toolbar-filter-count">{appliedFilters.length}</span>
          )}
        </button>
        {trailingAction}
      </div>

      {filterActive && (
        <div className="mobile-toolbar-chips">
          {appliedFilters}
          <button
            type="button"
            className="mobile-toolbar-clear-all"
            onClick={onClearAll}
          >
            Limpar tudo
          </button>
        </div>
      )}

      {!loading && (
        <p className="mobile-toolbar-results-count">
          {`${resultsCount} ${resultsNoun}${plural} encontrado${plural}`}
        </p>
      )}
    </>
  );
}
